import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, X, ShoppingCart } from "lucide-react";

export default function LowStockBanner({ items, onOpenPurchase }) {
  const [dismissed, setDismissed] = useState(false);
  const low = (items || []).filter((i) => (i.min_stock ?? 0) > 0 && (i.stock_quantity ?? 0) < i.min_stock);
  if (dismissed || low.length === 0) return null;

  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3.5 flex items-start gap-3" data-testid="low-stock-banner">
      <AlertTriangle className="h-5 w-5 text-amber-600 mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-amber-900">
          Low stock — {low.length} material{low.length > 1 ? "s" : ""} below reorder level
        </p>
        <div className="mt-1.5 flex flex-wrap gap-1.5" data-testid="low-stock-list">
          {low.map((i) => (
            <span
              key={i.sku}
              className="inline-flex items-center gap-1 rounded-md bg-white border border-amber-200 px-2 py-0.5 text-[11px] text-amber-800 font-mono-data"
              data-testid={`low-stock-chip-${i.sku}`}
            >
              <span className="font-semibold">{i.name}</span>
              <span className="text-amber-500">{(i.stock_quantity ?? 0).toLocaleString("en-IN")}/{i.min_stock.toLocaleString("en-IN")} {i.unit}</span>
            </span>
          ))}
        </div>
      </div>
      <div className="flex items-center gap-1.5 shrink-0">
        {onOpenPurchase && (
          <Button size="sm" className="h-8 text-xs bg-amber-600 hover:bg-amber-700" onClick={onOpenPurchase} data-testid="low-stock-reorder-btn">
            <ShoppingCart className="h-3.5 w-3.5 mr-1" /> Reorder
          </Button>
        )}
        <button onClick={() => setDismissed(true)} className="text-amber-400 hover:text-amber-700 transition-colors" title="Dismiss" data-testid="low-stock-dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
